import { Component, OnInit } from '@angular/core';
import {LoaderViewService} from '../../services/loader-view.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-loader-view',
  templateUrl: './loader-view.component.html',
  styleUrls: ['./loader-view.component.scss']
})
export class LoaderViewComponent implements OnInit {
  color = 'primary';
  mode = 'indeterminate';
  value = 50;

  isLoading: Subject<boolean> = this.loader.isLoading;
  constructor(
    private readonly loader: LoaderViewService
  ) { }

  ngOnInit(): void {
  }

}
